import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-external-apis',
  templateUrl: './external-apis.component.html',
  styleUrls: ['./external-apis.component.css']
})
export class ExternalApisComponent implements OnInit {
    public searchText: string | undefined;

    public itemsListExternalApis: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadExternalApis() {
        this.itemsListExternalApis = await this.datatask.Post(1438);
    }

    private async init() {
        this.loadExternalApis();
    }

    ngOnInit() {
        this.init();
    }
}
